import { makeAutoObservable } from "mobx";
import { ITag } from "../interfaces/ITag";
import ITagWithRelated, { tagsStore } from "./Tags";
import { settingsGl } from "./Settings";

class FilterTags {
  public listOfSelectedTags: ITagWithRelated[] = [];
  constructor() {
    makeAutoObservable(this);
  }
  public hasTag(tag: ITagWithRelated) {
    return this.listOfSelectedTags.filter((el) => {
      return el.id === tag.id;
    }).length;
  }
  public async onSelectCategory(tag: ITagWithRelated) {
    if (filterTagsGl.hasTag(tag)) {
      filterTagsGl.listOfSelectedTags = filterTagsGl.listOfSelectedTags.filter(
        (t) => t.id !== tag.id
      );
    } else {
      //единичынй выбор тэго
      filterTagsGl.listOfSelectedTags = [tag];
      //множетсвенный выбор
      // filterTagsGl.listOfSelectedTags.push({ ...tag });
    }
    await settingsGl.reloadEvents();
    tagsStore.orderBySelected(tagsStore.listOfTags);
  }
}
export const filterTagsGl = new FilterTags();
